"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All greeting specific translations
var Greetings = {
  greeting_morning: {
    nl: 'Morgend!',
    fr: 'Bonjour!',
    en: 'Goodmorning!',
    de: 'Guten Morgen!'
  },
  greeting_afternoon: {
    nl: 'Goeiemiddag!',
    fr: 'Bonne après-midi!',
    en: 'Good afternoon!',
    de: 'Guten Nachmittag!'
  },
  greeting_evening: {
    nl: 'Goeienavond!',
    fr: 'Bonsoir!',
    en: 'Good evening!',
    de: 'Guten Abend!'
  },
  greeting_holidays: {
    nl: 'Fijne feestdagen!',
    fr: 'Bonnes vacances!',
    en: 'Happy holidays!',
    de: 'Frohe Feiertage!'
  },
  greeting_neutral: {
    nl: 'Hey daar!',
    fr: 'Salut!',
    en: 'Hello!',
    de: 'Hallo!'
  }
};
var _default = Greetings;
exports["default"] = _default;